module.exports = __webpack_public_path__ + "static/media/f3.95f585c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f3.jpg
// module id = 396
// module chunks = 0